import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form", "results"];

  async update(event) {
    event.preventDefault();

    const form = event.target;
    const url = form.action;
    const formData = new FormData(form);

    try {
      const response = await fetch(url, {
        method: "PATCH",
        headers: { Accept: "application/json" },
        body: formData
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data = await response.json();

      // 1️⃣ Insert the tag text into the blurb
      this.insertIntoBlurb(data.name);

      // 2️⃣ Disable the clicked button
      const button = form.querySelector("input[type='submit']");
      if (button) {
        button.disabled = true;
        button.classList.add("btn-secondary");
      }

      // 3️⃣ Animate the tag candidate disappearing
      const wrapper = form.closest(".tag_candidate_form");
      if (wrapper) {
        wrapper.style.transition = "opacity 0.4s ease, transform 0.4s ease, height 0.4s ease";
        wrapper.style.overflow = "hidden";
        wrapper.style.opacity = "1";
        wrapper.style.transform = "translateY(0)";
        wrapper.style.height = `${wrapper.offsetHeight}px`;

        // Force layout before animation (browser quirk)
        wrapper.offsetHeight;

        // Start animation
        wrapper.style.opacity = "0";
        wrapper.style.transform = "translateY(-10px)";
        wrapper.style.height = "0";

        // Remove from DOM after animation
        setTimeout(() => wrapper.remove(), 400);
      }
    } catch (error) {
      console.error("TagCandidateController#update error:", error);
    }
  }

  async submit(event) {
    event.preventDefault();

    const form = event.target;
    const url = form.action;
    const formData = new FormData(form);
    const params = new URLSearchParams(formData).toString();

    try {
      const response = await fetch(`${url}?${params}`, {
        headers: { "Accept": "application/json" },
      });

      if (!response.ok) throw new Error(`Server responded with ${response.status}`);

      const data = await response.json();
      this.resultsTarget.innerHTML = data.html;
    } catch (error) {
      console.error("TagCandidateController#submit error:", error);
      this.resultsTarget.innerHTML = `
        <div class="alert alert-danger mt-2">
          Something went wrong while fetching tag candidates.
        </div>`;
    }
  }

  insertIntoBlurb(text) {
    if (!text) return;
    const blurb = document.getElementById("blurb-script");
    if (blurb) {
      const current = blurb.value.trim();
      blurb.value = current ? `${current} ${text}` : text;
    }
  }
}
